export enum ComponentName {
    CHANNEL_CARD_SKELETON = "ChannelCardSkeleton",
    CREDIT_CARD_SKELETON = "CreditCardSkeleton",
    MOVIE_CARD_SKELETON = "MovieCardSkeleton",
    PROGRAM_CARD_SKELETON = "ProgramCardSkeleton",
    TABSGENRES_CARD_SKELETON = "TabsGenresCardSkeleton",
}

export enum Skeleton {
    ID = 'skeleton'
}